import React from 'react';
import { msToH } from '../lib/time';
import {
  oneDecimal,
  useUpdatingDuration,
} from './shipment/useUpdatingDuration';
import type { InputProps } from './ui/Input/Input';
import Input from './ui/Input/Input';
import styled from 'styled-components';

const InputWithoutArrows = styled(Input)`
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;

export type DurationInputProps = InputProps & {
  showArrows?: boolean;
  overrideDuration: number | null;
  defaultDuration: number | null;
  onUpdateDuration: (newDuration: number | null) => void;
  max?: number | undefined;
};

export const DurationInput = React.memo(
  ({
    showArrows,
    overrideDuration,
    defaultDuration,
    onUpdateDuration,
    max,
    ...restProps
  }: DurationInputProps): JSX.Element => {
    const defaultDurationH =
      defaultDuration !== null ? msToH(defaultDuration) : null;
    const inputProps = useUpdatingDuration(
      overrideDuration,
      defaultDuration,
      onUpdateDuration,
      max,
    );

    const CustomInput = showArrows ? Input : InputWithoutArrows;

    return (
      <CustomInput
        {...restProps}
        type="number"
        placeholder={
          defaultDurationH !== null
            ? oneDecimal(defaultDurationH).toString()
            : ''
        }
        max={max}
        {...inputProps}
        style={{
          width: 60,
          ...inputProps.style,
        }}
      />
    );
  },
);
